import useOrganization from '~/components/OrganizationContext';

import type { ClaimFieldConfigType, ClaimFieldsConfigurationsResponse } from '../types';

type ReloadFieldsConfigurations = () => Promise<ClaimFieldsConfigurationsResponse | undefined>;

type MaybeFieldsConfigurations = ClaimFieldsConfigurationsResponse['fields_configurations'] | null;

interface PartialUseOrganizationContext {
  claimFieldsConfigurations: MaybeFieldsConfigurations;
  reloadClaimFieldsConfigurations: ReloadFieldsConfigurations;
  isErrorClaimFieldsConfigurations: boolean;
}

interface UseClaimFieldsConfigurationReturnType<T extends ClaimFieldConfigType> {
  fieldsConfiguration: ClaimFieldsConfigurationsResponse['fields_configurations'][T];
  reloadData: ReloadFieldsConfigurations;
  isError: boolean;
}

const useClaimFieldsConfiguration = <T extends ClaimFieldConfigType>(
  configType: T
): UseClaimFieldsConfigurationReturnType<T> => {
  const {
    claimFieldsConfigurations,
    reloadClaimFieldsConfigurations: reloadData,
    isErrorClaimFieldsConfigurations: isError,
  } = useOrganization() as PartialUseOrganizationContext;

  const fieldsConfiguration = claimFieldsConfigurations?.[configType] || [];

  return { fieldsConfiguration, reloadData, isError };
};

export default useClaimFieldsConfiguration;
